import { Checkbox, Form, Card, Typography } from "antd"
import { SafetyOutlined } from "@ant-design/icons"
import { convertListGroupPermissionToString } from "../../utils/perm-utils"
import { IOptionRole, IPermission } from "../../models/role.model"

const { Text } = Typography

type FieldType = {
    label: string,
    groupName: string,
    options: IOptionRole[],
    initValues?: (string | false)[],
}

const FormCheckbox = ({ label, groupName, options, initValues }: FieldType) => {
    const groupOptions = options.filter(item => item.group === groupName)

    return (
        <Card
            style={{
                marginBottom: '20px',
                borderRadius: '16px',
                border: '1px solid #e2e8f0',
                background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                overflow: 'hidden'
            }}
            title={
                <div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        color: '#2d3748',
                    }}>
                        <div style={{
                            background: 'rgba(255, 255, 255, 0.2)',
                            borderRadius: '10px',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <SafetyOutlined style={{
                                color: 'green',
                                fontSize: '20px',
                                filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))'
                            }} />
                            <Text style={{
                                marginLeft: '8px',
                                fontWeight: 600,
                                fontSize: '16px',
                                textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                            }}>
                                {label}
                            </Text>
                        </div>
                        <div>
                            <div style={{
                                fontSize: '14px',
                                color: '#666',
                            }}>
                                {groupOptions.length} quyền có sẵn
                            </div>
                        </div>
                    </div>
                </div>
            }
        >
            <Form.Item name={groupName} initialValue={initValues} style={{ margin: 0 }}>
                <Checkbox.Group
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px'
                    }}
                >
                    {groupOptions.map((option) => (
                        <div
                            key={option.value}
                            style={{
                                background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                                border: '1px solid #e2e8f0',
                                borderRadius: '12px',
                                padding: '4px 8px',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                cursor: 'pointer',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#667eea'
                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.15)'
                                e.currentTarget.style.transform = 'translateY(-2px)'
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#e2e8f0'
                                e.currentTarget.style.boxShadow = 'none'
                                e.currentTarget.style.transform = 'translateY(0)'
                            }}
                        >
                            <Checkbox
                                value={option.value}
                                style={{
                                    width: '100%',
                                    alignItems: 'center'
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    marginLeft: '8px'
                                }}>
                                    <Text style={{
                                        fontWeight: 500,
                                        color: '#2d3748',
                                        fontSize: '15px'
                                    }}>
                                        {option.label}
                                    </Text>
                                </div>
                            </Checkbox>
                        </div>
                    ))}
                </Checkbox.Group>
            </Form.Item>
        </Card>
    )
}

type ListFieldType = {
    options: IOptionRole[],
    initValues?: IPermission[],
}

export const ListFormCheckbox = ({ options, initValues }: ListFieldType) => {
    const groups = Array.from(
        new Map(options.map(item => [item.group, item])).values()
    )

    return (
        <>
            {groups.map(item => (
                <FormCheckbox
                    key={item.group}
                    label={item.name}
                    options={options}
                    groupName={item.group}
                    initValues={initValues && convertListGroupPermissionToString(initValues, item.group)}
                />
            ))}
        </>
    )
}
